import { z } from 'zod';

/**
 * Schéma pour la création/édition d'une leçon
 */
export const lessonSchema = z.object({
  title: z.string().min(3, 'Le titre doit contenir au moins 3 caractères'),
  description: z.string().optional(),
  typeId: z.coerce.number().min(1, 'Le type de leçon est requis'),
  duration: z.coerce
    .number()
    .min(5, 'La durée doit être au moins 5 minutes')
    .max(480, 'La durée ne peut pas dépasser 480 minutes (8 heures)'),
  chapterId: z.string().min(1, 'Le chapitre est requis'),
  statusId: z.coerce.number().min(1, 'Le statut est requis'),
  objectives: z.array(z.string()).optional(),
});

export type LessonFormData = z.infer<typeof lessonSchema>;
